// import NotificationTimeline from 'app/main/messages/notificationTimeline/NotificationTimeline'
// import Message from 'app/main/messages/Message'
import { Routes } from 'app/services/routeService/routeService'
import { AccessType } from 'app/auth/accessControlService'
import Analytics from 'app/main/messages/analytics/Analytics'
import Conversation from 'app/main/messages/conversations/Conversation'
import MessageTimeline from 'app/main/messages/timeline/MessageTimeline'
export const MessageConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: true,
        },
        toolbar: {
          display: true,
        },
        leftSidePanel: {
          display: true,
        },
      },
    },
  },
  routes: [
    {
      path: Routes.notificationTimeline(),
      component: MessageTimeline,
      exact: true,
      accesses: [
        AccessType.NOTIFICATION_VIEW_OWNED,
        AccessType.NOTIFICATION_VIEW_ALL,
        AccessType.ADMINISTRATION,
      ],
    },
    {
      path: Routes.notificationFavolites(),
      component: MessageTimeline,
      exact: true,
      accesses: [
        AccessType.NOTIFICATION_VIEW_OWNED,
        AccessType.NOTIFICATION_VIEW_ALL,
        AccessType.ADMINISTRATION,
      ],
    },
    {
      path: Routes.conversation(),
      component: Conversation,
      accesses: [AccessType.NOTIFICATION_VIEW_OWNED],
    },
    {
      path: Routes.analytics(),
      component: Analytics,
      accesses: [AccessType.ADMINISTRATION],
    },
  ],
}
